<template>
  <div class="flex flex-col w-full">
    <!-- TOP -->
    <div class="flex items-center justify-between gap-2">
      <!-- LEFT -->
      <slot name="topLeft" />
      <label
        v-if="topLeft"
        class="font-semibold text-sm text-surface-900"
        :for="labelFor"
      >
        {{ topLeft }}
      </label>
      <!-- RIGHT -->
      <slot name="topRight" />
      <span
        v-if="topRight"
        class="font-semibold text-sm text-surface-900"
      >
        {{ topRight }}
      </span>
    </div>

    <!-- BOTTOM -->
    <div class="flex items-center justify-between gap-2">
      <!-- LEFT -->
      <slot name="bottomLeft" />
      <span
        v-if="bottomLeft"
        class="text-xs text-surface-700 font-normal"
      >
        {{ bottomLeft }}
      </span>
      <!-- RIGHT -->
      <slot name="bottomRight" />
      <span
        v-if="bottomRight"
        class="text-xs text-surface-700 font-normal"
      >
        {{ bottomRight }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  topLeft: {
    type: String,
    required: false,
    default: '',
  },
  topRight: {
    type: String,
    required: false,
    default: '',
  },
  bottomLeft: {
    type: String,
    required: false,
    default: '',
  },
  bottomRight: {
    type: String,
    required: false,
    default: '',
  },
  labelFor: {
    type: String,
    required: false,
    default: undefined,
  },
})
</script>
